function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhaleprotection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-anchor",
    d: "m28.5 19.185-1.01 6.87-2.043-1.982a13.766 13.766 0 0 1-8.984 3.227 14.265 14.265 0 0 1-9.034-3.117l-1.865 1.81L4.5 19.185l7.016 1.033-1.935 1.877a10.161 10.161 0 0 0 5.6 2.221l-.006-11.208a3.889 3.889 0 0 1-2.658-3.648 4.011 4.011 0 0 1 8.018 0 3.89 3.89 0 0 1-2.735 3.67c.01 2.187.045 11.228 0 11.228 2.027 0 4.119-1.319 5.482-2.386l-1.806-1.754 7.024-1.033zM18.592 9.4a2.068 2.068 0 1 0-2.066 2 2.037 2.037 0 0 0 2.066-2z",
    transform: "translate(-4.498 -4.436)",
    style: {
      fill: "#204bf8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhaleprotection);
export default __webpack_public_path__ + "static/media/whaleprotection.2152aa8c6958e61949327d56a5c43634.svg";
export { ForwardRef as ReactComponent };